import { Button, Input, Form, message } from "antd";
import { useRouter } from "next/router";
import { useState } from "react";
import HttpService from "../../../services/HttpService";
import { ContactFormWrapper } from "./ContactForm.style";

export default function ContactForm({}) {
  const [sendMailLoading, setSendMailLoading] = useState(false);
  const [form] = Form.useForm();
  const router = useRouter();

  const handleSendMail = (values) => {
    setSendMailLoading(true);
    const http = new HttpService();
    http
      .postData(values, "send-email")
      .then((response) => {
        message.success(response);
        setSendMailLoading(false);
        setTimeout(() => {
          router.push("/");
        }, 2000);
      })
      .catch((response) => {
        message.error(response);
        setSendMailLoading(false);
      });
  };

  return (
    <ContactFormWrapper>
      <Form onFinish={handleSendMail} form={form}>
        <Input.Group compact>
          <Form.Item
            name="lastname"
            rules={[{ required: true, message: "Veuillez entrer votre nom." }]}
          >
            <Input placeholder="Nom" />
          </Form.Item>
          <Form.Item
            name="firstname"
            rules={[
              { required: true, message: "Veuillez entrer votre prénom." },
            ]}
          >
            <Input placeholder="Prénom" />
          </Form.Item>
        </Input.Group>
        <Input.Group compact>
          <Form.Item
            name="phone"
            rules={[
              {
                required: true,
                message: "Veuillez entrer votre numéro de téléphone.",
              },
              {
                pattern: new RegExp(/^((\+)33|0|0033)[1-9](\d{2}){4}$/g),
                message: "Veuillez entrer un numéro de téléphone valide.",
              },
            ]}
          >
            <Input placeholder="Téléphone" />
          </Form.Item>
          <Form.Item
            type="email"
            name="email"
            rules={[
              { required: true, message: "Veuillez entrer votre email." },
              { type: "email", message: "Veuillez entrer un email valide." },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>
        </Input.Group>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={sendMailLoading}>
            Programmez un RDV d'audit
          </Button>
        </Form.Item>
      </Form>
    </ContactFormWrapper>
  );
}
